<portal-sub-nav [force]="force" route="enterprise-users">
  <portal-menu-context [heading]="'menu.context.endUser' | portalTranslate"></portal-menu-context>

  <!-- Overview -->
  <portal-sub-nav-item
    *portalIsAuthorized="{
      anyPermission: [
        Permission.LIST_USERS,
        Permission.MANAGE_USER,
        Permission.VIEW_USER,
        Permission.VIEW_REGISTRATIONS,
        Permission.VIEW_DEVICES,
      ],
    }"
    [activeRoutes]="['end-user-import']"
    route="end-user-overview"
  >
    <ng-template portalTransclude>
      <span>{{ 'menu.endUsers' | portalTranslate }}</span>
    </ng-template>
  </portal-sub-nav-item>

  <!-- Phone Numbers -->
  <portal-sub-nav-item route="enterprise-phone-numbers">
    <ng-template portalTransclude>
      <span>{{ 'menu.phoneNumbers' | portalTranslate }}</span>
    </ng-template>
  </portal-sub-nav-item>

  <!-- Multiline Devices -->
  <portal-sub-nav-item
    *portalIsAuthorized="{
      anyPermission: [Permission.VIEW_DEVICES],
    }"
    route="enterprise-multiline-devices"
  >
    <ng-template portalTransclude>
      <span>{{ 'menu.multilineDevices' | portalTranslate }}</span>
    </ng-template>
  </portal-sub-nav-item>

  <!-- Registrations -->
  <portal-sub-nav-item
    *portalIsAuthorized="{
      anyPermission: [Permission.VIEW_ANY_REGISTRATIONS, Permission.VIEW_REGISTRATIONS],
    }"
    route="end-user-registrations"
  >
    <ng-template portalTransclude>
      <span>{{ 'menu.registrations' | portalTranslate }}</span>
    </ng-template>
  </portal-sub-nav-item>
</portal-sub-nav>
